<template>
  <div class="widget" :class="style">
    <div ref="widget_container" class="container">
      <div class="header">{{ title || "Атрибут title указан" }}</div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Название'
    }
  },
  data() {
    return {
      width: 0,
      height: 0,
      min_desktop_width: 500,
    };
  },

  mounted() {
    this.refresh_sizes();
    window.onresize = this.refresh_sizes;
  },

  computed: {
    style() {
      if (this.width > this.min_desktop_width) return "desktop";
      return "mobile";
    },
  },

  methods: {
    refresh_sizes() {
      if (this.$refs.widget_container) {
        this.width = this.$refs.widget_container.clientWidth;
        this.height = this.$refs.widget_container.clientHeight;
        let tmp = {
          width: this.width,
          height: this.height,
          style: this.style,
        };
        this.$emit("resize", tmp);
      }
    },
  },
};
</script>

<style scoped>
/* стиль элемента-обертки для удобного встраивания виджета на страницу */
.widget {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* основной элемент виджета  - его пользователь и видит*/
.widget > .container {
  margin: auto;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
  background: white;

  border: 1px dashed orangered;
  padding: 15px;
  box-sizing: border-box;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}

.widget.mobile > .container {
  min-height: 730px;
  padding: 0;
}

.widget > .container > .header {
  flex-grow: 0;
  font-weight: bold;
  font-size: 14pt;
  text-align: center;
  border-bottom: 1px dashed #fc5a0a;
  padding-bottom: 15px;
  margin: 10px 10px 5px;
  color: black;
  width: auto;
}

.widget.mobile > .container > .header {
  font-size: 14pt;
  padding-bottom: 5px;
  margin: 10px 10px 0;
}

.widget > .container > .content {
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  overflow: hidden;
}

</style>

<style>
.widget.desktop .mobile_only {
  display: none; //TODO: надо убрать отсюда
}
</style>
